export default __webpack_public_path__ + "static/media/bg5.d2767853.png";